<template>
  <RModal
    ref="modal"
    full-size
    max-width="650px"
    max-height="auto"
    :persistent="false"
    :title="title"
    @ok="onSave"
    @cancel="onCancel"
  >
    <template #default="{ hide, setLoading, isLoading }">
      <Grid
        v-if="form"
        gtc="1fr 1fr"
        gap="var(--r-space-md)"
        class="q-pt-lg"
        @keyup.enter="!isLoading && onSave(hide, setLoading)"
      >
        <q-input
          v-model="$v.form.ip_address.$model"
          :error="$v.form.ip_address.$error"
          :error-message="$v_displayMessage($v.form.ip_address)"
          hide-bottom-space
          autofocus
          label="Ip Address *"
          outlined
        />

        <q-select
          v-model="$v.form.provider_id.$model"
          :error="$v.form.provider_id.$error"
          :error-message="$v_displayMessage($v.form.provider_id)"
          hide-bottom-space
          :options="providers ? providers : []"
          :loading="!providers"
          label="Provider *"
          option-label="name"
          option-value="id"
          outlined
          emit-value
          map-options
        />

        <q-input v-model="form.location" autofocus label="Location" outlined />
        <q-input v-model="form.description" autofocus label="Description" outlined autogrow />
        <q-input v-model="form.ip_range" label="Ip Range" outlined />
        <q-checkbox v-model="form.should_be_dispatched" label="Notify Provider" />
      </Grid>
    </template>
  </RModal>
</template>

<script>
import * as apiTo from '@/modular-api'
import { validations } from './validations'
// Components
import RModal from '@/ui/RModal'

export default {
  components: {
    RModal
  },

  mixins: [validations],

  data: () => ({
    editItem: null,
    /** @type {IpAddressPayload} */
    form: undefined,
    /** @type {ProviderResponse[]} */
    providers: undefined
  }),

  computed: {
    title() {
      if (this.editItem) return `Edit Ip Address`
      return `Create new Ip Address`
    }
  },

  created() {
    this.getAndSetProviders()
  },

  methods: {
    getAndSetProviders() {
      apiTo.PROVIDERS().then(({ data }) => {
        this.providers = data.result
      })
    },

    /** @param {IpAddress} [editItem] */
    show(editItem) {
      this.$v.$reset()
      this.editItem = editItem
      this.setForm(editItem)
      this.$refs.modal.show()
    },

    /** @param {IpAddressResponse | {}} [editItem] */
    setForm(editItem = {}) {
      this.form = {
        ip_address: editItem.ip_address ?? null,
        provider_id: editItem.provider?.id ?? null,
        location: editItem.location ?? null,
        description: editItem.description ?? null,
        ip_range: editItem.ip_range ?? null,
        should_be_dispatched: editItem.should_be_dispatched || false
      }
    },

    onSave(hideModal, setModalLoading) {
      if (!this.$v_validationPass()) return

      setModalLoading()

      if (this.editItem) this.update(hideModal, setModalLoading)
      else this.create(hideModal, setModalLoading)
    },

    create(hideModal, setModalLoading) {
      apiTo
        .IP_ADDRESSES_CREATE(this.form)
        .then(({ data }) => {
          this.$emit('created', data.result)
          hideModal()
        })
        .finally(() => setModalLoading(false))
    },

    update(hideModal, setModalLoading) {
      apiTo
        .IP_ADDRESSES_UPDATE(this.form, this.editItem.id)
        .then(({ data }) => {
          this.$emit('updated', data.result)
          hideModal()
        })
        .finally(() => setModalLoading(false))
    },

    onCancel(hideModal) {
      hideModal()
    }
  }
}
</script>
